import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  setting: null,
};

// TODO: fetch all the setting
export const fetchSetting = createAsyncThunk(
  "fetchSetting/setting",
  async ({ enqueueSnackbar, limit, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`settings`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create setting
export const createSetting = createAsyncThunk(
  "createSetting/setting",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`settings/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update setting
export const updateSetting = createAsyncThunk(
  "updateSetting/setting",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`settings/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete setting
export const deleteSetting = createAsyncThunk(
  "deleteSetting/setting",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const settinglice = createSlice({
  name: "setting",
  initialState,
  extraReducers: (builder) => {
    // TODO: create setting
    builder.addCase(fetchSetting.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSetting.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.setting = action.payload;
      state.isLoading = false;
    });

    builder.addCase(fetchSetting.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(action.payload.error || action.payload.error.message),
        {
          variant: "error",
        }
      );
    });

    // TODO: create setting
    builder.addCase(createSetting.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createSetting.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Setting is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createSetting.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(action.payload.error || action.payload.error.message),
        {
          variant: "error",
        }
      );
    });

    // TODO: update setting
    builder.addCase(updateSetting.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateSetting.fulfilled, (state, action) => {
      state.isLoading = false;
      state.setting.data = state.setting.data.map((setting) => {
        if (setting.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return setting;
        }
      });
      action.payload.enqueueSnackbar("SETTING is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateSetting.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(action.payload.error || action.payload.error.message),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete setting
    builder.addCase(deleteSetting.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteSetting.fulfilled, (state, action) => {
      state.isLoading = false;
      state.setting.data = state.setting.data.filter(
        (setting) => setting.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("SETTING is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteSetting.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(action.payload.error || action.payload.error.message),
        {
          variant: "error",
        }
      );
    });
  },
});

export default settinglice.reducer;
